import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  dates: [],
  schools: [],
  categories: [],
  schoolStages: [],
  classes: {},
  total: null,
  isTotalFetching: false,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setDates = (state, payload) => (
  object.setIn(state, [ 'dates' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)

export const setClasses = (state, payload) => (
  object.setIn(state, [ 'classes', payload.schoolId ], payload.classes)
)

export const setCategories = (state, payload) => (
  object.setIn(state, [ 'categories' ], payload)
)

export const setSchoolStages = (state, payload) => (
  object.setIn(state, [ 'schoolStages' ], payload)
)

export const setTotalFetching = (state, payload) => (
  object.setIn(state, [ 'isTotalFetching' ], payload)
)

export const setTotal = (state, payload) => (
  object.setIn(state, [ 'total' ], payload)
)
